import { useTranslations } from "next-intl";
import isProductInCollection from "src/helpers/storefront-helpers/isProductInCollection";
import useCountryData from "src/hooks/useCountryData";
import { KoalaProduct } from "src/types/koala/KoalaProduct";
import { CountryCode } from "src/types/localization/CountryCode";
import { Product } from "src/types/storefront";

interface InformationProps {
  productHandle: string;
}

const Information = ({ productHandle }: InformationProps) => {
  const t = useTranslations("ProductOverview");
  const countryData = useCountryData();

  // const [openReturnPolicyModal, setOpenReturnPolicyModal] = useState(false);
  return (
    <>
      <section className="flex flex-col gap-2.5">
        <h3 className="font-semibold">{t("shipping")}</h3>
        <p>
          {t("shipping_body", {
            amount: countryData?.shipping.freeLimit,
            currency: countryData?.currency,
          })}
        </p>

        {productHandle != "wash-bag" && (
          <>
            <h3 className="font-semibold">{t("care_instructions")}</h3>
            <ul className="list-disc">
              {[1, 2, 3, 4, 5, 6].map((step) => (
                <li key={step}>
                  <p>{t(`care_instructions_body_${step}`)}</p>
                </li>
              ))}
            </ul>
          </>
        )}
      </section>
      {/* <ReturnPolicyModal
        open={openReturnPolicyModal}
        setOpen={setOpenReturnPolicyModal}
      /> */}
    </>
  );
};

// const Information = ({ product }: InformationProps) => {
//   const t = useTranslations("ProductOverview");
//   const countryData = useCountryData();

//   let isCareInstructionsVisible = true;

//   if (
//     isProductInCollection(product.collections, countryData?.collections.COLLECTION_ACCESSORIES.id) &&
//     countryData?.code == CountryCode.EG
//   ) {
//     isCareInstructionsVisible = false;
//   }

//   // const [openReturnPolicyModal, setOpenReturnPolicyModal] = useState(false);
//   return (
//     <>
//       <section className="flex flex-col gap-2.5">
//         <h3 className="font-semibold">{t("shipping")}</h3>
//         <p>
//           {t("shipping_body", {
//             amount: countryData?.shipping.freeLimit,
//             currency: countryData?.currency,
//           })}
//         </p>
//         {isCareInstructionsVisible && (
//           <>
//             <h3 className="font-semibold">{t("care_instructions")}</h3>
//             <p>{t("care_instructions_body")}</p>
//           </>
//         )}
//         {countryData?.bundleDiscountSystems && (
//           <>
//             <h3 className="font-semibold">{t("bundle_discount")}</h3>
//             <p>{t("bundle_discount_body")}</p>
//           </>
//         )}
//       </section>
//       {/* <ReturnPolicyModal
//         open={openReturnPolicyModal}
//         setOpen={setOpenReturnPolicyModal}
//       /> */}
//     </>
//   );
// };

export default Information;
